// eslint-disable-next-line import/prefer-default-export
export const WERKZEUGBAU_SUBSTATI = 'werkzeugbau_substati';
